import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=b2bd0b54&scoped=true&"
import script from "./Mark.vue?vue&type=script&lang=ts&"
export * from "./Mark.vue?vue&type=script&lang=ts&"
import style1 from "./Mark.vue?vue&type=style&index=1&id=b2bd0b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bd0b54",
  null
  
)

export default component.exports